import Vue from 'vue'
import 'es6-promise/auto'
import VueLazyload from 'vue-lazyload'
import App from './App'
import router from './router'
import store from './store'
import _ from './dateFormat'
import LazyImage from "./page-lib/directives/LazyImage";

import PhotoSwipe from "photoswipe/dist/photoswipe";
import PhotoSwipeUI from "photoswipe/dist/photoswipe-ui-default";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import createPreviewDirective from "vue-photoswipe-directive";

const previewDirective = createPreviewDirective(
  {
    shareEl: false,
    fullscreenEl: false,
    bgOpacity: 0.9, // 背景透明度
    allowPanToNext: false,
  },
  PhotoSwipe,
  PhotoSwipeUI,
)


Vue.use(VueLazyload, {
  lazyComponent: true,
})
Vue.directive("lazy-image", LazyImage)
Vue.directive("preview", previewDirective)
Vue.config.performance = true

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
